import React, { Component } from 'react';

import InitialLogo from '../logos/InitialLogo';
import AnnualLogo from '../logos/AnnualLogo';
import { history } from '../../state/store';
import { AuthService } from '../../state/auth.service';

class AuthenticatedNavbar extends Component {
  constructor(props, context) {
    super(props, context);

    this.signOut = this.signOut.bind(this);
  }

  signOut() {
    AuthService.signOut();
    history.push('/account/signin');
  }

  render() {
    const user = AuthService.getUser();
    let userName = 'Account';
    if (user.name && user.name.length > 0) {
      userName = user.name;
    }

    return (
      <header className="Navbar">
        <div className="Navbar__logo">
          <a href={`${process.env.PUBLIC_URL}/../initial/consultant/dashboard`}>
            <InitialLogo />
          </a>
          <span className="slash">/</span>
          <a href={`${process.env.PUBLIC_URL}/../annual/consultant/dashboard`}>
            <AnnualLogo />
          </a>
        </div>
        <nav>
          <ul>
            <li className="user-name">{userName}</li>
            <li>
              <button className="logout-button" onClick={this.signOut}>
                Logout
              </button>
            </li>
          </ul>
        </nav>
      </header>
    );
  }
}

export default AuthenticatedNavbar;



// WEBPACK FOOTER //
// ./src/components/navbar/authenticated.js